import React, { useState } from "react";
import doc from "../SuggestionsList/SuggestItem/document.svg";
import css from "../AutoSamplete.module.css";
import TrafficLights from "../../TrafficLights";

function ItemDisplay({
  contract_id,
  contract_name,
  summary,
  date_added,
  finance_sign_off
}) {
  const [isClicked, setIsClicked] = useState(false);
  return (
    <div className={css.itemdisplaydiv}>
      <h2 className={css.itemname}>Provider: {contract_name}</h2>
      <p className={css.itemID}>ID: {contract_id}</p>
      <p className={css.itemsummary}>Summary: {summary}</p>
      <p className={css.itemdate}>Date added: {date_added}</p>
      <p className={css.itemboolean}>
        Finance Authorisation: {isClicked ? "True" : "False"}
      </p>
      <TrafficLights isClicked={isClicked} setIsClicked={setIsClicked} />
      {/* <img className={css.itemcontractpic} src={doc} alt="contract" /> */}
    </div>
  );
}

export default ItemDisplay;
